import getConfig from 'next/config';

import * as Sentry from '@sentry/nextjs';

const { APP_ENV } = getConfig().publicRuntimeConfig;
const { SENTRY_DSN, IMAGE_VERSION } = getConfig().serverRuntimeConfig;

if (['production', 'staging'].includes(APP_ENV)) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,
    release: IMAGE_VERSION,
    tracesSampleRate: 0.01,
  });
}
